export const webappPaths = {
  login: '/login',
};

export const authPaths = {
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
};

export const onHoldReason = {
  email: 'email',
  subscription: 'subscription',
  payment: 'payment',
  trial: 'trial',
};

export const appPaths = {
  base: '/app',
  chart: '/app/chart',
  chartV2: '/app/chartv2',
  kgInsight: '/app/kg-insight',
  alfred: '/app/alfred',
  screener: '/app/screener',
  scenario: '/app/scenario',
  insights: '/app/insights',
  onboarding: '/app/onboarding',
  research: '/app/2-alfred',
  news: '/app/news',
  insightFeed: '/app/stream',
  alerts: '/app/alerts',
  settings: {
    base: '/app/settings',
    subscription: '/app/settings/subscription',
    account: '/app/settings/account',
    appearance: '/app/settings/appearance',
    portfolio: '/app/settings/portfolio',
  },
  verifyEmail: '/app/verify-email',
  accountOnHold: '/app/account-on-hold',
  error: '/app/error',
  notFound: '*',
  website: '/',
  alfredAppConnection: '/app/alfred/app-connection',
  assetOverview: '/app/asset-overview',
  themeOverview: '/app/theme',
  watchlist: '/app/watchlist',
  events: '/app/events',
  ib: '/app/ib',
  tos: '/app/terms-of-service',
};

export const accountRoutes = {
  checkout: 'checkout',
  billingInformation: 'billing-information',
};

export const drawerKeys = {
  themeOverviewTab: 'themeOverviewTab',
} as const;
